import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 用户管理
 * @type {{logout(): Promise<AxiosResponse<*>>, login(*=, *=): Promise<AxiosResponse<*>>}}
 */
const user = {

  /**
   * 获取用户信息
   * @returns {Promise<AxiosResponse<any>>}
   */
  getUserInfo() {
    return axios.get('/thesis/user/getUserInfo')
  },

  /**
   * 添加一个用户
   * @param user
   */
  addUser(user) {
    return axios.post('/thesis/user',user)
  },

  /**
   * 修改用户信息
   * @param user
   */
  updateUser(user){
    return axios.put('/thesis/user',user)
  },

  /**
   * 删除用户
   * @param id  用户id
   */
  deleteUser(id){
    return axios.delete('/thesis/user/'+id);
  },

  /**
   * 修改密码
   * @param id
   * @param oldPassword
   * @param newPassword
   */
  updatePwd(id,oldPassword,newPassword){
    let param = new URLSearchParams()
    param.append('id', id)
    param.append('oldPassword', oldPassword)
    param.append('newPassword', newPassword)
    return axios.post('/thesis/user/updatePwd',param);
  },

  /**
   * 得到所有用户
   * @param user
   * @returns {Promise<AxiosResponse<any>>}
   */
  getUserList(userTypeEnum){
    let param = new URLSearchParams()
    param.append('userTypeEnum', userTypeEnum)
    return axios.get('/thesis/user/getUserList?userTypeEnum='+userTypeEnum)
  },

  /**
   * 查询所有的管理员和审核员
   * @return
   */
  getUserListOfManagerAndReferee(){
    return axios.get('/thesis/user/getUserListOfManagerAndReferee')
  }
}


export default user



// WEBPACK FOOTER //
// ./src/api/user.js